<div class="gender-holder">
  <div class="container">
    <div class="img-holder-gender" (click)="genderSelect('female')">
      <img class="gender-img" src="assets/general/female.png" />
    </div>
    <button
      class="submit-active"
      (click)="genderSelect('female')"
      *ngIf="gender === 'female'"
    >
      <div class="title-active">خانم</div>
    </button>
    <div
      class="submit-disable"
      (click)="genderSelect('female')"
      *ngIf="gender === undefined || gender === 'male'"
    >
      <div class="title-disable">خانم</div>
    </div>
  </div>
  <div class="container">
    <div class="img-holder-gender" (click)="genderSelect('male')">
      <img class="gender-img" src="assets/general/male.png" />
    </div>
    <button
      class="submit-active"
      (click)="genderSelect('male')"
      *ngIf="gender === 'male'"
    >
      <div class="title-active">آقا</div>
    </button>
    <div
      class="submit-disable"
      (click)="genderSelect('male')"
      *ngIf="gender === undefined || gender === 'female'"
    >
      <div class="title-disable">آقا</div>
    </div>
  </div>
</div>
